import Hero from "@/sections/Hero";
import BrandIntro from "@/sections/BrandIntro";
import ModernProblem from "@/sections/ModernProblem";
import ServicePreview from "@/sections/ServicePreview";
import OffersPreview from "@/sections/OffersPreview";
import WhoFor from "@/sections/WhoFor";
import FinalCTA from "@/sections/FinalCTA";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <BrandIntro />
      <ModernProblem />
      <ServicePreview />
      <OffersPreview />
      <WhoFor />
      <FinalCTA />
    </main>
  );
}
